import { render, staticRenderFns } from "./HelpGuide.vue?vue&type=template&id=08672e07&scoped=true&"
import script from "./HelpGuide.vue?vue&type=script&lang=js&"
export * from "./HelpGuide.vue?vue&type=script&lang=js&"
import style0 from "./HelpGuide.vue?vue&type=style&index=0&id=08672e07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08672e07",
  null
  
)

export default component.exports